<template>
  <button
    @click="showModal = true"
    :disabled="disabled"
    :title="`Delete ${entityNamePlural}`"
  >
    <span> Delete <font-awesome-icon icon="trash-can" /> </span>

    <teleport to="body">
      <modal
        v-if="showModal"
        @reject="showModal = false"
        @accept="deleteAction"
        acceptText="Delete now"
        :title="`Delete ${entityNamePlural}`"
      >
        <span
          >Are you sure you want to delete {{ selectionCount }}
          {{ entityNameForCount }}?</span
        >
      </modal>
    </teleport>
  </button>
</template>
<script>
import Modal from "../Modal.vue";
import Teleport from "vue2-teleport";

export default {
  name: "DeleteAction",
  components: {
    Modal,
    Teleport
  },
  props: {
    disabled: Boolean,
    entityName: String,
    entityNamePlural: String,
    entityNameForCount: String,
    selectionCount: Number,
    selectOrFilter: Object
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    deleteAction() {
      this.$emit("deleteAction", this.selectOrFilter);
      this.showModal = false;
    }
  }
};
</script>
